import React from 'react';

import { ReactComponent as PmrGreen } from '../../../assets/pmr-green-big.svg';
import { ReactComponent as PmrYellow } from '../../../assets/pmr-yellow-big.svg';
import { ReactComponent as PmrRed } from '../../../assets/pmr-red-big.svg';
import { ReactComponent as PmrGray } from '../../../assets/pmr-gray-big.svg';
import { PmrClassification } from '../../../models/PmrClassification';

export const PmrClassificationBig = (props: any) => {
  const colorClassification: PmrClassification = props.classificationColor;

  return colorClassification === PmrClassification.Green ? (
    <PmrGreen />
  ) : colorClassification === PmrClassification.Yellow ? (
    <PmrYellow />
  ) : colorClassification === PmrClassification.Red ? (
    <PmrRed />
  ) : (
    <PmrGray />
  );
};
